import { ItemUser } from 'data/firestore/globals';

export default function getValueForAvatar(createdBy?: ItemUser, agentId?: string) {
    if (createdBy?.uid) return createdBy?.uid;
    if (createdBy?.role === 'agent') return agentId;
    return 'unknown';
}
